import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const EmailCodeSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Text,
    id: "code",
    label: "인증 코드",
    placeholder: "인증코드 6자리를 입력하세요.",
    behavior: {
      required: true,
    },
  },
];
